import React, { Component } from 'react';
import './iamExKeys.css';
import {Auth} from 'aws-amplify';
import AWS from 'aws-sdk';
import {readableDate} from '../../../universal/utils/index.js';
import IamExKeTitle from './iamExKeTitle/iamExKeTitle.js';
import IamExKeContent from './iamExKeContent/iamExKeContent.js';

class IamExKeys extends Component {

  state = {
    iamAuditUsers: [],
    updateDate: ''
  };

  componentDidMount() {

    setTimeout(() => {
      Auth.currentCredentials()
      .then(credentials => {
        this.S3 = new AWS.S3({credentials: Auth.essentialCredentials(credentials)});
        return this.downloadIamAudit();
      })
      .catch(err => {
        console.log(err);
      });
    }, 0);

  };

    downloadIamAudit = () => {

      return this.S3.getObject({Bucket: 'weaveability-basis-utilities-storage', Key: 'iamAudit/iamAudit.json', IfModifiedSince: new Date(2000)}).promise()
      .then(res => {
        const updateDate = readableDate(res.LastModified);
        this.setState({iamAuditUsers: JSON.parse(res.Body.toString()).Users, updateDate});
      });

    };

    render() {

      return (
        <div className="IamExKeysPage">
          <IamExKeTitle/>
          <IamExKeContent
            users={this.state.iamAuditUsers}
          />
        </div>
      );
    };

};

export default IamExKeys;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExKeys/iamExKeys.js